import bugsnag from 'bugsnag-js'
import LogRocket from 'logrocket'
//USER ACTIONS
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL'
export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL'
export const SHOW_FORGOT_PASSWORD_MODAL = 'SHOW_FORGOT_PASSWORD_MODAL'
export const HIDE_FORGOT_PASSWORD_MODAL = 'HIDE_FORGOT_PASSWORD_MODAL'
export const FORGOT_PASSWORD_SUBMITTING = 'FORGOT_PASSWORD_SUBMITTING'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
export const USER_LOGGING_IN = 'USER_LOGGING_IN'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR'
export const USER_LOGGING_OUT = 'USER_LOGGING_OUT'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR'
export const UNEXPECTED_ERROR_MESSAGE = 'Looks like we have a flat tire, please try again.'

//BOOKING STEPS
export const BOOKING_STEP = {
  CAR_INFO: 'CAR_INFO',
  SERVICE_INFO: 'SERVICE_INFO',
  DATE_LOCATION_INFO: 'DATE_LOCATION_INFO',
  GARAGE_DATE_LOCATION_INFO: 'GARAGE_DATE_LOCATION_INFO',
  CUSTOMER_INFO: 'CUSTOMER_INFO',
  REVIEW_INFO: 'REVIEW_INFO'
}

export const BOOKING_FLOW_CONFIGS = {
  DEFAULT_FLOW: 'DEFAULT_FLOW',
  GARAGE_FLOW: 'GARAGE_FLOW'
}

//STEP STATES
export const STEP_STATE = {
  NOT_STARTED: 'wait',
  PROCESSING: 'process',
  ERRORED_OUT: 'error',
  FINISHED: 'finish'
}

//BOOKING STEP ACTIONS
export const BOOKING_ACTION = {
  STEP_START: 'STEP_START',
  STEP_SUBMIT: 'STEP_SUBMIT',
  STEP_ERROR: 'STEP_ERROR',
  STEP_COMPLETE: 'STEP_COMPLETE',
  JUMP_TO_STEP: 'JUMP_TO_STEP',
  SET_CAR: 'SET_CAR',
  RESET: 'RESET'
}

export const SERVICE_SELECTION = {
  TOGGLE_SERVICE_SELECTION: 'TOGGLE_SERVICE_SELECTION',
  SET_SERVICE_DATA: 'SET_SERVICE_DATA',
  SET_ADDITIONAL_NOTES: 'SET_ADDITIONAL_NOTES'
}

//SERVICE OPTIONS
export const SERVICE_OPTIONS = {
  OIL_CHANGE: 'oilChange',
  BRAKE_SERVICE: 'brakeService',
  TIRE_SERVICE: 'tireService',
  SCHEDULED_MAINTENANCE: 'scheduledMaintenance',
  EXTERIOR_WASH: 'exteriorWash',
  EXTERIOR_DETAIL: 'exteriorDetail',
  INTERIOR_DETAIL: 'interiorDetail',
  ADDITIONAL_NOTES: 'additionalNotes'
  //PAINT_CORRECTION: 'paintCorrection',
}

console.log('build context is ' + process.env.REACT_APP_CONTEXT)
export const API_ROOT = process.env.REACT_APP_API_ROOT
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
export const FB_PIXEL_EVENT_ID = process.env.REACT_APP_FB_PIXEL_EVENT_ID
export const BUGSNAG_API_KEY = process.env.REACT_APP_BUGSNAG_API_KEY
export const LOGROCKET_API_KEY = process.env.REACT_APP_LOGROCKET_API_KEY
export const bugsnagClient = bugsnag({
  apiKey: BUGSNAG_API_KEY,
  releaseStage: process.env.REACT_APP_CONTEXT || 'development',
  notifyReleaseStages: ['production'],
  beforeSend: function(report) {
    report.updateMetaData('LogRocket', {
      sessionURL: LogRocket.sessionURL
    })
  }
})

export const INTERCOM_KEY = process.env.REACT_APP_INTERCOM_KEY
console.log('API_ROOT is  ' + API_ROOT)



// WEBPACK FOOTER //
// ./src/constants/AppConstants.js